import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'antd'
import { formatReminderNumber } from '../../services/utils'
import css from './contact-mapping.css'

const sortByPreferred = ({ is_preferred: aPref }, { is_preferred: bPref }) =>
  (aPref === bPref ? 0 : aPref ? -1 : 1)

const listPhoneNumbers = (numbers, countryCode) => {
  const plus = countryCode === 'NZ' ? '' : '+'
  return numbers
    .sort(sortByPreferred)
    .map(num =>
      `${plus}
       ${formatReminderNumber(num.phone_number)}
       ${num.is_preferred ? '*' : ''}`)
    .join(', ')
}

const ExistingPhoneNumbers = ({
  locationCountryCode,
  purchasedNumbers,
  requiresPhoneNumberPurchase,
  showEditButton,
  smseUsers,
  toggleModal,
}) => {
  const remindersPhoneNumbers = listPhoneNumbers(
    purchasedNumbers,
    locationCountryCode,
  )

  return (
    <React.Fragment>
      {requiresPhoneNumberPurchase && (
        <div className={css.phoneOrEmailWrapper}>
          <div className={css.headerWithButton}>
            <span className={css.labelSmall}>Reminders phone numbers</span>
            {showEditButton && (
              <div
                className={css.editButton}
                onClick={() => toggleModal(true, 'edit')}
              >
                <Icon type="edit" />
              </div>
            )}
          </div>
          <span className={css.md}>
            <div dangerouslySetInnerHTML={{ __html: remindersPhoneNumbers }} />

          </span>
        </div>
      )}
      {!!smseUsers[0] && (
        <div className={css.phoneOrEmailWrapper}>
          <span className={css.labelSmall}>
            This practice will share a phone number with all New Zealand
            practices,
            <br />
            but replies will be delivered to the correct practice.
          </span>
        </div>
      )}
    </React.Fragment>
  )
}

ExistingPhoneNumbers.propTypes = {
  locationCountryCode: PropTypes.string.isRequired,
  purchasedNumbers: PropTypes.arrayOf(PropTypes.shape({
    phone_number: PropTypes.string.isRequired,
  })).isRequired,
  requiresPhoneNumberPurchase: PropTypes.bool.isRequired,
  smseUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
  toggleModal: PropTypes.func.isRequired,
}

export default ExistingPhoneNumbers



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/ExistingPhoneNumbers.js